import React, { useEffect } from "react";
import AskQuestionContent from "./ask/ask-question-content";

const AskUse = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <AskQuestionContent />
  )
}

export default AskUse;
